// frontend/src/core/api/admin.js

// Universal admin endpoints. Region-agnostic.
import { apiFetch } from './client';

export const fetchAdminUsers = (token) =>
  apiFetch('/api/admin/users', { token });

export const fetchAdminSubscriptions = (token) =>
  apiFetch('/api/admin/subscriptions', { token });

export const fetchAdminDomains = (token) =>
  apiFetch('/api/admin/domains', { token });

export const toggleAdmin = (userId, token) =>
  apiFetch('/api/admin/users/toggle-admin', {
    method: 'POST',
    token,
    body: JSON.stringify({ user_id: userId }),
  });

export const updateSubscription = (payload, token) =>
  apiFetch('/api/admin/subscriptions/update', {
    method: 'POST',
    token,
    body: JSON.stringify(payload),
  });

export const createSubscription = (payload, token) =>
  apiFetch('/api/admin/subscriptions/create', {
    method: 'POST',
    token,
    body: JSON.stringify(payload),
  });